import React from 'react';

function Policies() {
  return (
    <article className="seo-page-container" style={{ 
      padding: 'clamp(15px, 4vw, 30px)', 
      background: '#fff', 
      margin: 'clamp(10px, 3vw, 20px)', 
      borderRadius: '4px', 
      textAlign: 'left', 
      fontFamily: 'Arial, sans-serif',
      boxSizing: 'border-box'
    }}>
      
      <header>
        <h1 style={{ 
          color: '#0b3c5d', 
          marginBottom: '15px', 
          fontSize: 'clamp(1.5rem, 6vw, 2.4rem)', 
          fontWeight: '700', 
          lineHeight: '1.3' 
        }}>
          Website Policies: Data Encryption Protocols & Privacy Frameworks
        </h1>
        <p style={{ fontSize: '0.9rem', color: '#666', fontWeight: 'bold', margin: 0 }}>System Logging Update Matrix: June 23, 2026</p>
      </header>

      <section style={{ marginTop: '30px', color: '#333', lineHeight: '1.7', fontSize: '0.95rem' }}>
        
        <h2 style={{ color: '#0b3c5d', fontSize: 'clamp(1.15rem, 4.5vw, 1.4rem)', borderBottom: '1px solid #eee', paddingBottom: '6px', marginTop: '20px' }}>1. Secure Technical Infrastructure</h2>
        <p style={{ color: '#444', marginBottom: '20px' }}>
          At <strong>Medical Trip World</strong>, we process all digital communications and user form queries using standard Secure Sockets Layer (SSL) encryption configurations. This technical setup helps protect user metadata and input values from unauthorized interception during transit, ensuring a private, independent research environment.
        </p>

        <h2 style={{ color: '#0b3c5d', fontSize: 'clamp(1.15rem, 4.5vw, 1.4rem)', borderBottom: '1px solid #eee', paddingBottom: '6px', marginTop: '20px' }}>2. Cookies and Tracking Data Usage</h2>
        <p style={{ color: '#444', marginBottom: '20px' }}>
          Our platform uses basic operational cookies exclusively to remember your language preferences, track keyword search queries, and optimize page rendering speeds across mobile and desktop devices. No health records, biological data, or confidential medical conditions are tracked or stored within these browser memory packages.
        </p>

        <h2 style={{ color: '#0b3c5d', fontSize: 'clamp(1.15rem, 4.5vw, 1.4rem)', borderBottom: '1px solid #eee', paddingBottom: '6px', marginTop: '20px' }}>3. Independent Review Policy</h2>
        <p style={{ color: '#444', margin: 0 }}>
          We do not accept financial compensation to alter search positions, prioritize specific clinical profiles, or modify directory listings. Every private corporate hospital featured on our network is organized purely on verifiable public data benchmarks, historical infrastructure performance, and active international accreditation records.
        </p>

      </section>

    </article>
  );
}

export default Policies;